import { createContext, useContext, useMemo, useState } from "react";

const SelectedCommerceApiStoreInfosValueContext = createContext();
const SelectedCommerceApiStoreInfosActionsContext = createContext();

export function SelectedCommerceApiStoreInfosContextProvider({ children }) {
    const [commerceApiStoreInfos, setCommerceApiStoreInfos] = useState([]);

    const commerceApiStoreInfosActions = useMemo(
        () => {
            return {
                onSet(newValues) {
                    setCommerceApiStoreInfos(newValues);
                },
                setValue: setCommerceApiStoreInfos
            }
        },
        []
    )

    return (
        <>
            <SelectedCommerceApiStoreInfosActionsContext.Provider value={{ commerceApiStoreInfos: commerceApiStoreInfosActions }}>
                <SelectedCommerceApiStoreInfosValueContext.Provider value={{ commerceApiStoreInfos }}>
                    {children}
                </SelectedCommerceApiStoreInfosValueContext.Provider>
            </SelectedCommerceApiStoreInfosActionsContext.Provider>
        </>
    );
}

export function useSelectedCommerceApiStoreInfosValueContextHook(props) {
    const value = useContext(SelectedCommerceApiStoreInfosValueContext);

    if (value === undefined) {
        throw new Error('useSelectedCommerceApiStoreInfosValueContextHook should be used within SelectedCommerceApiStoreInfosValueContext');
    }

    return {
        commerceApiStoreInfos: value.commerceApiStoreInfos
    };
}

export function useSelectedCommerceApiStoreInfosActionsContextHook(props) {
    const value = useContext(SelectedCommerceApiStoreInfosActionsContext);

    if (value === undefined) {
        throw new Error('useSelectedCommerceApiStoreInfosActionsContextHook should be used within SelectedCommerceApiStoreInfosActionsContext');
    }

    return {
        commerceApiStoreInfos: {
            onSet: value.commerceApiStoreInfos.onSet,
            setValue: value.commerceApiStoreInfos.setValue
        }
    };
}